import React from 'react'
import moment from 'moment'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CFormText
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import FormInvoiceRecipients from 'src/components/form/general-input-form/FormInvoiceRecipients'

// helpers
import { convertMoney } from '../../../helpers/format-number'

const AppDetails = ({
  invoiceDetails,
  handleViewFile
}) => {
  let fileBupot = []
  let fileFaktur = []
  let fileShipping = []
  let shippingDetail = invoiceDetails?.shipping_detail ? invoiceDetails?.shipping_detail : null

  if (invoiceDetails?.bupot_url) {
    fileBupot = [{
      file_url: invoiceDetails?.bupot_url,
      file_original_name: invoiceDetails?.bupot_original_name
    }]
  }
  if (invoiceDetails?.faktur_url) {
    fileFaktur = [{
      file_url: invoiceDetails?.faktur_url,
      file_original_name: invoiceDetails?.faktur_original_name
    }]
  }
  if (shippingDetail?.shipping_attachments && shippingDetail?.shipping_attachments.length > 0) {
    fileShipping = shippingDetail?.shipping_attachments.map(file => ({
      file_url: file.file_url,
      file_original_name: file.file_original_name
    }))
  }
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Invoice name"
          subtitle={invoiceDetails?.name}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Invoice value"
          subtitle={`IDR ${convertMoney(invoiceDetails?.value)}`}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Tax and other fees"
          subtitle={`IDR ${convertMoney(invoiceDetails?.tax_value)}`}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Invoice Description"
          subtitle={invoiceDetails?.description}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Invoice due date"
          subtitle={moment(invoiceDetails?.due_date).format('DD/MM/YYYY')}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Invoice tax due date"
          subtitle={moment(invoiceDetails?.tax_due_date).format('DD/MM/YYYY')}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Invoice expected payment date"
          subtitle={moment(invoiceDetails?.expected_payment_date).format('DD/MM/YYYY')}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Project name"
          subtitle={invoiceDetails?.project ? invoiceDetails?.project?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Invoice number"
          subtitle={invoiceDetails?.invoice_number ? invoiceDetails?.invoice_number : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Paid?"
          subtitle={invoiceDetails?.is_paid ? 'Yes' : 'No'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Invoice payment date"
          subtitle={invoiceDetails?.payment_date ? moment(invoiceDetails?.payment_date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Draft?"
          subtitle={invoiceDetails?.is_draft ? 'Yes' : 'No'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Bukti potong PPh 23"
          subtitle={invoiceDetails?.bupot_required ? 'Yes' : 'No'}
        />
        <CCol>
          <CFormLabel>
            Document bukti potong PPh 23
          </CFormLabel>
          {
            fileBupot?.length > 0 ? (
              <FormFileThumbnail 
                colSize="6"
                files={fileBupot}
                isDetailPage={true}
                handleViewFile={handleViewFile}
              />
            ) : (
              <CCol>
                <CFormText>
                  No attachment
                </CFormText>
              </CCol>
            )
          }
        </CCol>
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Faktur pajak"
          subtitle={invoiceDetails?.faktur_required ? 'Yes' : 'No'}
        />
        <CCol>
          <CFormLabel>
            Document faktur pajak
          </CFormLabel>
          {
            fileFaktur?.length > 0 ? (
              <FormFileThumbnail 
                colSize="6"
                files={fileFaktur}
                isDetailPage={true}
                handleViewFile={handleViewFile}
              />
            ) : (
              <CCol>
                <CFormText>
                  No attachment
                </CFormText>
              </CCol>
            )
          }
        </CCol>
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          className={'mb-3'}
          title="Client name"
          subtitle={invoiceDetails?.client ? invoiceDetails?.client?.name : '-'}
        />
        {
          shippingDetail ? (
            <>
              {
                shippingDetail?.is_soft_copy && (
                  <>
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Recipient"
                      subtitle={shippingDetail?.recipient ? shippingDetail?.recipient : '-'}
                    />
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Email to"
                      subtitle={shippingDetail?.email_to ? shippingDetail?.email_to : '-'}
                    />
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Email date"
                      subtitle={shippingDetail?.email_date ? moment(shippingDetail?.email_date).format('DD/MM/YYYY') : '-'}
                    />
                  </>
                )
              }
              {
                shippingDetail?.is_hard_copy && (
                  <>
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Courier"
                      subtitle={shippingDetail?.courier ? shippingDetail?.courier?.toUpperCase() : '-'}
                    />
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Tracking number"
                      subtitle={shippingDetail?.tracking_no ? shippingDetail?.tracking_no : '-'}
                    />
                    <AppTextColumnDetails
                      colSize="4"
                      className={'mb-3'}
                      title="Shipping date"
                      subtitle={shippingDetail?.shipping_date ? moment(shippingDetail?.shipping_date).format('DD/MM/YYYY HH:mm:ss') : '-'}
                    />
                  </>
                )
              }
            </>
          )
          : null
        }
      </CRow>
      {
        shippingDetail && (shippingDetail?.is_soft_copy || shippingDetail?.is_hard_copy) ? (
          <CRow className='mb-4'>
            <CCol lg={12}>
              <CFormLabel>
                Shipping Attachments
              </CFormLabel>
              {
                fileShipping?.length > 0 ? (
                  <FormFileThumbnail 
                    colSize='4'
                    files={fileShipping}
                    isDetailPage={true}
                    handleViewFile={handleViewFile}
                  />
                ) : (
                  <CCol>
                    <CFormText>
                      No attachment
                    </CFormText>
                  </CCol>
                )
              }
            </CCol>
          </CRow>
        ) : null
      }
      <CRow className='mb-4'>
        <FormInvoiceRecipients 
          inputLabel={'Invoice Recipients'}
          recipients={invoiceDetails.recipients}
          isDetail={true}
        />
      </CRow>
    </>
  )
}

export default AppDetails
